/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import Grid from '@mui/material/Grid';

import UIGrid from '../uigrid';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css'; // Core grid CSS, always needed

let isFlag = '';
const RoTable = (props) => {
  const { stageData, unit_set_dict, roDictData, translateObject } = props;
  const [roRowData1, setRoRowData1] = useState([]);
  const [roRowData2, setRoRowData2] = useState([]);
  const roData = stageData;
  const options = JSON.parse(localStorage.getItem('options'));
  const abFactor = get(options, 'abFactor', '0');
  // const SatJsonData = stageData.sat_indices;
  // made the changes by Chandrashekar on 6th Feb 24 to handle backend empty data
  const SatJsonData = stageData.sat_indices || stageData.product.sat_indices;
  const [roColData1] = useState(Number(abFactor) === 1 ? [
    { tag: 'stage', hdata: `${translateObject('Stage')}`, maxWidth: 50, minWidth: 20, disabled: true },
    { tag: 'vessel', hdata: `${translateObject('Vessels')}`, minWidth: 20, disabled: true },
    { tag: 'no_elem', hdata: `${translateObject('No. of Elements')}`, disabled: true },
    { tag: 'elem_type', hdata: `${translateObject('Element Type')}`, disabled: true },
    { tag: 'feed', hdata: `${translateObject('Feed Flow')} (${unit_set_dict['Volume Flow']})`, disabled: true },
    { tag: 'conc', hdata: `${translateObject('Conc. Flow')} (${unit_set_dict['Volume Flow']})`, disabled: true },
    { tag: 'perm', hdata: `${translateObject('Perm Flow')} (${unit_set_dict['Volume Flow']})`, disabled: true },
    { tag: 'recovery', hdata: `% ${translateObject('Recovery')}` }
  ] : [
    { tag: 'stage', hdata: `${translateObject('Stage')}`, maxWidth: 50, minWidth: 20, disabled: true },
    { tag: 'vessel', hdata: `${translateObject('Vessels')}`, minWidth: 20, disabled: true },
    { tag: 'no_elem', hdata: `${translateObject('No. of Elements')}`, disabled: true },
    { tag: 'elem_type', hdata: `${translateObject('Element Type')}`, disabled: true },
    { tag: 'age', hdata: `${translateObject('Age')}`, minWidth: 20, disabled: true },
    { tag: 'feed', hdata: `${translateObject('Feed Flow')}(${unit_set_dict['Volume Flow']})`, disabled: true },
    { tag: 'conc', hdata: `${translateObject('Conc. Flow')} (${unit_set_dict['Volume Flow']})`, disabled: true },
    { tag: 'perm', hdata: `${translateObject('Perm Flow')} (${unit_set_dict['Volume Flow']})`, disabled: true },
    { tag: 'recovery', hdata: `% ${translateObject('Recovery')}` }
  ]);
  function getValue(item, num) {
    return Number.parseFloat(item).toFixed(num);
  }
  function getFluxValue(item, num) {
    if (unit_set_dict.Flux === 'm/s') {
      return Number.parseFloat(item).toExponential(num);
    }
    return Number.parseFloat(item).toFixed(num);
  }
  function getFlowValue(item, num) {
    if (unit_set_dict['Volume Flow'] === 'm3/s') {
      if (item >= 0.01) {
        return Number.parseFloat(item).toFixed(num);
      }
      return Number.parseFloat(item).toExponential(num);
    }
    return Number.parseFloat(item).toFixed(num);
  }
  const [roColData2] = useState([
    { tag: 'stage', hdata: `${translateObject('Stage')}`, maxWidth: 50, minWidth: 20, datatype: 'text', disabled: true },
    { tag: 'last_elem', hdata: `${translateObject('Last Element Beta')}`, datatype: 'text', disabled: true },
    { tag: 'feed', hdata: `${translateObject('Feed Pressure')} (${unit_set_dict.Pressure})`, datatype: 'text', disabled: true },
    { tag: 'delta', hdata: `${translateObject('Delta Pressure')} (${unit_set_dict.Pressure})`, datatype: 'text', disabled: true },
    { tag: 'avg', hdata: `${translateObject('Avg.')} (${unit_set_dict.Flux})`, datatype: 'text', disabled: true },
    { tag: 'feedtds', hdata: `${translateObject('Feed TDS')}`, datatype: 'text', disabled: true },
    { tag: 'permtds', hdata: `${translateObject('Perm TDS')}`, datatype: 'text', disabled: true },
    {
      tag: 'afactor', hdata: `${abFactor === '0' ? `${translateObject('A-Value ACP')}` : `${translateObject('A-Factor')}`}`,
      datatype: 'text', disabled: true
    },
    {
      tag: 'bfactor', hdata: `${abFactor === '0' ? `${translateObject('B-Value ACP')}` : `${translateObject('B-Factor')}`}`,
      datatype: 'text', disabled: true
    }
  ]);

  useEffect(() => {
    const roarr_rowdata1 = [];
    const roarr_rowdata2 = [];
    roData.stage.map((data, i) => {
      const lengthCheck = (roDictData && roDictData['grid-data'] && roDictData['grid-data'].length);
      const num_vessels = lengthCheck ? roDictData['grid-data'][i].pressureVessels : data.num_vessels;
      const pres_vessels = lengthCheck ? roDictData['grid-data'][i].elementsperVessel : data.pres_vessels[0].module.length;
      const element_type = lengthCheck ? roDictData['grid-data'][i].elementModel : data.pres_vessels[0].module[0].element_type;
      const element_age = lengthCheck ? roDictData['grid-data'][i].elementAge : data.pres_vessels[0].module[0].age;
      roarr_rowdata1.push(Number(abFactor) === 1 ? {
        stage: i + 1,
        vessel: num_vessels,
        no_elem: pres_vessels,
        elem_type: element_type,
        feed: getFlowValue(data.feed_flow, 2),
        conc: getFlowValue(data.conc_flow, 2),
        perm: getFlowValue(data.perm_flow, 2),
        recovery: getValue(data.recovery, 2)
      } : {
        stage: i + 1,
        vessel: num_vessels,
        no_elem: pres_vessels,
        elem_type: element_type,
        age: element_age,
        feed: getFlowValue(data.feed_flow, 2),
        conc: getFlowValue(data.conc_flow, 2),
        perm: getFlowValue(data.perm_flow, 2),
        recovery: getValue(data.recovery, 2)
      });
      // if data.pres_vessels[0].module[i] values is exits take the data data.pres_vessels[0].module[i]
      // otherwise take the data data.pres_vessels[0].module[0]
      // In CLRO only one module data that's the condition check
      const moduleValue = data.pres_vessels[0].module[0];
      roarr_rowdata2.push({
        stage: i + 1, last_elem: getValue(data.last_elem_beta, 2),
        feed: getValue(data.feed_press, 2), delta: getValue(data.delta_press, 2), avg: getFluxValue(data.avg_flux, 2),
        feedtds: getValue(data.feed_tds, 2), permtds: getValue(data.perm_tds, 2),
        afactor: getValue(moduleValue.a_value, 2),
        bfactor: getValue(moduleValue.b_value, 2)
      });
    });
    setRoRowData1(roarr_rowdata1);
    setRoRowData2(roarr_rowdata2);
    isFlag = stageData.unique_id;
  }, (isFlag === stageData.unique_id) ? [null, null] : [roRowData1, roRowData2]);
  return (
    <div className="App">
      <Grid container>
        <Grid item xs={10} sm={12} md={12} lg={9} xl={9}>
          <div className="ro_latest_table" style={{ height: '100%', fontSize: '12px' }}>
            <UIGrid
              data={roRowData1}
              properties={roColData1}
            />
            <div style={{ marginTop: '1%' }} />
            <UIGrid
              data={roRowData2}
              properties={roColData2}
            />
          </div>
        </Grid>
        <Grid item xs>
          <div className="ag-theme-alpine ag-custom stream-modal" style={{ marginTop: '2%' }}>
            <div style={{ fontSize: '12px', color: '#2C2C2C' }} className="box-border rufusReg M_Bold">
              {translateObject('Saturation Data(Concentrate)')}</div>
            <div className="form-grid sansW4SeLig expSatDataCon">
              {[
                { key: 'BaSO4', value: SatJsonData.baso4 },
                { key: 'CaF2', value: SatJsonData.caf2 },
                { key: 'CaSO4', value: SatJsonData.caso4 },
                { key: 'SiO2', value: SatJsonData.sio2 },
                { key: 'SrSO4', value: SatJsonData.srso4 },
                { key: 'Struvite', value: SatJsonData.struvite },
                { key: 'LSI', value: SatJsonData.lsi },
                { key: 'SDSI', value: SatJsonData.sdi },
                { key: 'Osm.Press', value: `${getValue(SatJsonData.osmotic_pressure, 2)} ${unit_set_dict.Pressure}` },
                { key: 'Conductivity', value: `${SatJsonData.conductivity} µS/cm` },
              ].map((ele) => {
                return (
                  <div className="box-column w-50 label-text S_Regular">
                    <div className='f-left sub-left no_drag'>{ele.key}</div>
                    <div className='f-right sub-right no_drag'>{ele.value}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default RoTable;